import FormComponent from './components/FormComponent';

window.addEventListener('vue-init', () => {
    mountVueComponent('form', FormComponent);
})

if (typeof(mountVueComponent) == 'function') {
    mountVueComponent('form', FormComponent);
}
